<template>
  <Transition name="optimize">
    <div
      v-if="visible"
      class="optimize-panel"
    >
      <!-- Header -->
      <div class="panel-header">

        <div class="title">

          <img src="@/assets/casesearchImg/icon-recognition2.png" class="icon">

          <div>

            <div class="name">
              AI 已优化检索问题
            </div>
          </div>

        </div>

        <a-button
          type="text"
          @click="handleClose"
        >
          ✕
        </a-button>

      </div>

      <!-- Loading -->
      <a-spin :spinning="loading">
        <div class="question-wrapper">

            <!-- 原始问题 -->
            <div class="question-card">
            <div class="label">
                原始问题
            </div>

            <div class="content">
                {{ originalQuestion }}
            </div>
            </div>

            <!-- AI优化后的问题 -->
            <div class="question-card optimize">
            <div class="label">
                AI优化后的问题
            </div>

            <div class="content">
                {{ optimizedQuestion }}
            </div>
            </div>

        </div>
        </a-spin>

      <!-- Footer -->

      <div class="footer">

        <a-space>

          <a-button
            @click="handleKeep"
          >
            保留原问题
          </a-button>

          <a-button
            @click="$emit('retry')"
          >
            重新优化
          </a-button>

          <a-button
            type="primary"
            @click="handleReplace"
          >
            使用优化问题
          </a-button>

        </a-space>

      </div>

    </div>

  </Transition>
</template>

<script setup>

const props = defineProps({

  visible:{

    type:Boolean,

    default:false

  },

  loading:{

    type:Boolean,

    default:false

  },

  originalQuestion:{

    type:String,

    default:''

  },

  optimizedQuestion:{

    type:String,

    default:''

  }

})

const emit = defineEmits([

'close',

'keep',

'replace',

'retry'

])

const handleClose=()=>{

  emit("close")

}

const handleKeep=()=>{

  emit("keep")

}

const handleReplace=()=>{

  emit("replace",props.optimizedQuestion)

}

</script>

<style scoped lang="less">

.optimize-panel{

    margin-top:20px;

    background:#F8FBFF;

    border:1px solid #DCEBFF;

    border-radius:16px;

    overflow:hidden;

}

.panel-header{

    display:flex;

    justify-content:space-between;

    align-items:center;

    padding:18px 22px;

    border-bottom:1px solid #E8F2FF;

}

.title{

    display:flex;

    align-items:center;

}

.icon{

    width:24px;

    height:24px;

    // border-radius:50%;

    // background:#1677ff;

    color:#fff;

    display:flex;

    align-items:center;

    // justify-content:center;

    // font-size:20px;

    margin-right:14px;

}

.name{

    font-weight: 600;
    font-size: 17px;
    color: #244F9B;
    // line-height: 21px;
    text-shadow: 0px 8px 24px rgba(36,70,130,0.08);

}

.desc{

    margin-top:4px;

    color:#86909C;

    font-size:13px;

}

// .question-card{

//     margin:22px;

//     padding:18px;

//     background:#fff;

//     border-radius:12px;

//     border:1px solid #E5EAF3;
    

// }

.optimize{

    border-color:#91C3FF;

    background:#F4F9FF;

}

.label{

    color:#1677ff;

    font-size:15px;

    font-weight:600;

    margin-bottom:12px;

}

.content{

    line-height:30px;

    color:#4E5969;

    white-space:pre-wrap;

    font-size:15px;

}

.footer{

    padding:20px 22px;

    display:flex;

    justify-content:flex-end;

    background:#fff;

    border-top:1px solid #EEF2F7;

}

.optimize-enter-active,

.optimize-leave-active{

    transition:.25s;

}

.optimize-enter-from,

.optimize-leave-to{

    opacity:0;

    transform:translateY(-10px);

}
.question-wrapper {
  display: flex;
  gap: 20px;
  padding: 20px;
}

.question-card {
  flex: 1;
  min-width: 0;

  padding: 18px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #E5EAF3;
}

.question-card.optimize {
  background: #F4F9FF;
  border-color: #91C3FF;
}

.label {
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  font-size: 15px;
  font-weight: 600;
  color: #1768FF;
}

.content {
  min-height: 140px;
  line-height: 28px;
  color: #4E5969;
  white-space: pre-wrap;
  word-break: break-all;
}

@media (max-width: 768px) {
  .question-wrapper {
    flex-direction: column;
  }
}
</style>